<template>
  <div class="d-flex flex-row gap-4">
    <div v-for="item in legendItems" :key="item.label" class="d-flex gap-2">
      <span class="legend-square" :class="item.class"></span>
      <small style="line-height: 12px" class="text--color-text-tertiary">{{ item.label }}</small>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'LimitsLegend',
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['counter', 'limiter'].includes(value)
    }
  },
  setup(props) {
    const { t } = useI18n();
    const legendItems = computed(() => {
      if (props.type === 'limiter') {
        return [
          {
            label: t('appointment.dialogs.limitsOverviewDialog.legend.remaining'),
            class: 'bg-grey'
          },
          {
            label: t('appointment.dialogs.limitsOverviewDialog.legend.scheduled'),
            class: 'bg-info'
          }
        ];
      }
      return [
        { label: t('appointment.dialogs.limitsOverviewDialog.legend.remaining'), class: 'bg-grey' },
        {
          label: t('appointment.dialogs.limitsOverviewDialog.legend.safeRange'),
          class: 'bg-success'
        },
        {
          label: t('appointment.dialogs.limitsOverviewDialog.legend.warningRange'),
          class: 'bg-yellow'
        },
        {
          label: t('appointment.dialogs.limitsOverviewDialog.legend.criticalRange'),
          class: 'bg-red'
        }
      ];
    });

    return {
      t,
      legendItems
    };
  }
});
</script>

<style scoped>
.legend-square {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}
</style>
